import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

export default function TableHeader({ className, children }) {
  return (
    <thead className={cn('cp-table-header', className)}>
      <tr>{children}</tr>
    </thead>
  );
}

TableHeader.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired
};
